export enum ContratoVersao {
  V1 = 'V1',
  V2 = 'V2',
  V3 = 'V3',
}
